import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface NoticeModalData {
  title: string;
  message: string;
  /** Tints the heading; 'error' by default. */
  kind?: 'error' | 'warning' | 'info';
}

/**
 * A message with one way out.
 *
 * The app's replacement for alert(): the same job, but themed, translated and
 * laid out like everything else. ConfirmMessageModalComponent is the wrong
 * shape for this — it offers Cancel and Confirm, and there is nothing here to
 * confirm.
 */
@Component({
  selector: 'app-notice-modal',
  templateUrl: './notice-modal.component.html',
  styleUrls: ['./notice-modal.component.scss']
})
export class NoticeModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: NoticeModalData) {}

  get icon(): string {
    switch (this.data?.kind) {
      case 'warning': return 'warning_amber';
      case 'info': return 'info';
      default: return 'error_outline';
    }
  }
}
